import {$qsAll} from '../../@shared/ts/dom';
import {getBoundedRecaptchaToken} from '../../@shared/ts/recaptcha';
import {Feature} from './features';
import {FeatureFlag} from '../../@type/features';
import {getCheckoutForm} from './checkout';

function installCaptchaScript() {
	const script = document.createElement('script');
	script.setAttribute('src', 'https://www.google.com/recaptcha/api.js?render=' + Feature.metadata(FeatureFlag.BOT_PROTECTION, 'site_key'));

	script.async = true;
	script.defer = true;

	document.body.appendChild(script);
}

async function getCaptchaTokenForNative(): Promise<string | null> {
	if (typeof grecaptcha === 'undefined' || typeof grecaptcha.ready !== 'function') {
		console.error('[PP-BotProtection] grecaptcha is not loaded. Verify the reCAPTCHA script is not blocked and the site key is valid.');
		return null;
	}

	const siteKey = Feature.metadata<string>(FeatureFlag.BOT_PROTECTION, 'site_key') ?? '';
	if (!siteKey) {
		console.error('[PP-BotProtection] reCAPTCHA site key is missing in PeachPay settings.');
		return null;
	}

	return getBoundedRecaptchaToken(grecaptcha, {
		siteKey,
		action: 'NATIVE_CHECKOUT',
		onTimeout() {
			console.error('[PP-BotProtection] reCAPTCHA token generation timed out after 8000ms. The script may be blocked or execute may be stalled.');
		},
		onError(error) {
			console.error('[PP-BotProtection] reCAPTCHA token generation failed.', error);
		},
	});
}

async function insertCaptchaFields(checkoutForm: HTMLFormElement | null = null): Promise<void> {
	if (!checkoutForm) {
		checkoutForm = getCheckoutForm();
	}

	if (!Feature.enabled(FeatureFlag.BOT_PROTECTION)) {
		return;
	}

	const token = await getCaptchaTokenForNative();
	if (!token) {
		// Without a token the server-side validation will reject the order with
		// "Failed to generate captcha token...". We log above so the merchant
		// can diagnose, but we still continue so the existing UX (a clear
		// server-side notice) is preserved.
		return;
	}

	const $nativeCheckoutFlag = document.createElement('input');
	$nativeCheckoutFlag.type = 'hidden';
	$nativeCheckoutFlag.name = 'peachpay_captcha_token';
	$nativeCheckoutFlag.value = token;
	checkoutForm?.insertAdjacentElement('beforeend', $nativeCheckoutFlag);
}

function cleanupCaptchaFields() {
	$qsAll('input[name="peachpay_captcha_token"]', $el => {
		$el.remove();
	});
}

export {
	installCaptchaScript,
	insertCaptchaFields,
	cleanupCaptchaFields,
};
